const translations = {
  en: {
    withdrawUsing: 'Withdraw using',
    accountNumberPlaceholder: 'Account Number',
    routingPlaceholder: '9 digit Routing (ABA)',
    currency: 'Currency',
    amountPlaceholder: 'Amount',
    payoutLimits: 'PayoutLimits: Minimum',
    maximum: 'Maximum',
    noLimit: 'No Limit',
    bankInformation: 'Bank information',
    bankName: 'Bank name:',
    bankNamePlaceholder: 'bank name',
    bankCountry: 'Bank Country:',
    bankState: 'Bank State:',
    bankCity: 'Bank City:',
    bankCityPlaceholder: 'bank city',
    bankAddress: 'Bank Address:',
    bankAddressPlaceholder: 'bank address',
    personalInformation: 'Personal information',
    firstName: 'First Name:',
    firstNamePlaceholder: 'first name',
    lastName: 'Last name:',
    lastNamePlaceholder: 'last name',
    email: 'Email:',
    emailPlaceholder: 'email',
    phone: 'Phone #:',
    phonePlaceholder: 'phone #',
    country: 'Country:',
    countryPlaceholder: 'Country',
    state: 'State:',
    stateProvPlaceholder: 'State / Prov',
    city: 'City:',
    cityPlaceholder: 'city',
    zipcode: 'Zipcode:',
    zipcodePlaceholder: 'zipcode',
    address: 'Address:',
    addressPlaceholder: 'address',
    back: 'BACK',
    submit: 'SUBMIT',
    warning: 'Warning',
    error: 'Error',
    amountRequired: 'Amount required',
    withdrawalStatus: 'Withdrawal Status',
    amountNotPermitted: 'amount not permitted, please check your withdrawal balance',
    errorGettingCustomerInfo: 'Error getting customer info: ',
  },
  es: {
    withdrawUsing: 'Retirar usando',
    accountNumberPlaceholder: 'Número de Cuenta',
    routingPlaceholder: 'Ruta de 9 dígitos (ABA)',
    currency: 'Moneda',
    amountPlaceholder: 'Monto',
    payoutLimits: 'Límites de retiro: Mínimo',
    maximum: 'Máximo',
    noLimit: 'Sin Límite',
    bankInformation: 'Información Bancaria',
    bankName: 'Nombre del banco:',
    bankNamePlaceholder: 'nombre del banco',
    bankCountry: 'País del Banco:',
    bankState: 'Estado del Banco:',
    bankCity: 'Ciudad del Banco:',
    bankCityPlaceholder: 'ciudad del banco',
    bankAddress: 'Dirección del Banco:',
    bankAddressPlaceholder: 'dirección del banco',
    personalInformation: 'Información Personal',
    firstName: 'Nombre:',
    firstNamePlaceholder: 'nombre',
    lastName: 'Apellido:',
    lastNamePlaceholder: 'apellido',
    email: 'Correo:',
    emailPlaceholder: 'correo',
    phone: 'Teléfono #:',
    phonePlaceholder: 'teléfono #',
    country: 'País:',
    countryPlaceholder: 'País',
    state: 'Estado:',
    stateProvPlaceholder: 'Estado / Provincia',
    city: 'Ciudad:',
    cityPlaceholder: 'ciudad',
    zipcode: 'Código Postal:',
    zipcodePlaceholder: 'código postal',
    address: 'Dirección:',
    addressPlaceholder: 'dirección',
    back: 'ATRÁS',
    submit: 'ENVIAR',
    warning: 'Advertencia',
    error: 'Error',
    amountRequired: 'Monto requerido',
    withdrawalStatus: 'Estado del Retiro',
    amountNotPermitted: 'Monto no permitido, por favor verifique su saldo disponible para retiro',
    errorGettingCustomerInfo: 'Error al obtener información del cliente: ',
  },
  pt: {
    withdrawUsing: 'Sacar usando',
    accountNumberPlaceholder: 'Número de Conta',
    routingPlaceholder: 'Roteamento de 9 dígitos (ABA)',
    currency: 'Moeda',
    amountPlaceholder: 'Valor',
    payoutLimits: 'Limites de saque: Mínimo',
    maximum: 'Máximo',
    noLimit: 'Sem Limite',
    bankInformation: 'Informações Bancárias',
    bankName: 'Nome do banco:',
    bankNamePlaceholder: 'nome do banco',
    bankCountry: 'País do Banco:',
    bankState: 'Estado do Banco:',
    bankCity: 'Cidade do Banco:',
    bankCityPlaceholder: 'cidade do banco',
    bankAddress: 'Endereço do Banco:',
    bankAddressPlaceholder: 'endereço do banco',
    personalInformation: 'Informações Pessoais',
    firstName: 'Nome:',
    firstNamePlaceholder: 'nome',
    lastName: 'Sobrenome:',
    lastNamePlaceholder: 'sobrenome',
    email: 'E-mail:',
    emailPlaceholder: 'e-mail',
    phone: 'Telefone #:',
    phonePlaceholder: 'telefone #',
    country: 'País:',
    countryPlaceholder: 'País',
    state: 'Estado:',
    stateProvPlaceholder: 'Estado / Província',
    city: 'Cidade:',
    cityPlaceholder: 'cidade',
    zipcode: 'CEP:',
    zipcodePlaceholder: 'CEP',
    address: 'Endereço:',
    addressPlaceholder: 'endereço',
    back: 'VOLTAR',
    submit: 'ENVIAR',
    warning: 'Aviso',
    error: 'Erro',
    amountRequired: 'Valor obrigatório',
    withdrawalStatus: 'Status do Saque',
    amountNotPermitted: 'Valor não permitido, por favor verifique seu saldo disponível para saque',
    errorGettingCustomerInfo: 'Erro ao obter informações do cliente: ',
  },
}

export default translations
